import {Component, Input} from "@angular/core";
import {DbActiveModal} from "../../../../../modules/modal/modal-ref";


@Component({
    selector: 'db-successful-popup',
    templateUrl: './successful-popup.component.html',
    styleUrls: ['./successful-popup.component.scss'],
    standalone: false
})
export class SuccessfulPopupComponent  {
  @Input() title: string;
  @Input() description: string;

  constructor(
    public activeModal: DbActiveModal
  ) {}

}
